import { getScheduleAction } from '../components/schedule/actions';

export function setScheduleInterval(filter, dispatch) {
    const ticketsInterval = localStorage.getItem('scheduleUpdateInterval') ? JSON.parse(localStorage.getItem('scheduleUpdateInterval')) : [];
    const newInterval = setInterval(() => {
        dispatch(getScheduleAction(filter, true));
    }, 5000);
    ticketsInterval.push(newInterval);
    localStorage.setItem('scheduleUpdateInterval', JSON.stringify(ticketsInterval));
}

export function unsetScheduleInterval() {
    if (localStorage.getItem('scheduleUpdateInterval')) {
        const ticketsIntervals = JSON.parse(localStorage.getItem('scheduleUpdateInterval'));
        ticketsIntervals.forEach(intervalID => clearInterval(+intervalID));
    }
    localStorage.setItem('scheduleUpdateInterval', JSON.stringify([]));
}
